document.addEventListener('DOMContentLoaded', () => {
    let swiperInstances = [];

    function initSwipers() {
        const viewportWidth = window.innerWidth;
        const swiperElements = document.querySelectorAll('.info-bar-swiper'); 

        swiperElements.forEach((swiperElement, index) => {
            if (viewportWidth < 1025) {
                if (!swiperElement.swiper) {
                    swiperInstances[index] = new Swiper(swiperElement, {
                        speed: 400,
                        spaceBetween: 20,
                        slidesPerView: 1,
                        loop: true,
                        autoHeight: false,
                        autoplay: {
                            delay: 5000, 
                            disableOnInteraction: false, 
                        },
                        pagination: {
                            el: swiperElement.querySelector('.swiper-pagination'),
                            clickable: true,
                        },
                    });
                }
            } else {
                if (swiperElement.swiper) {
                    swiperElement.swiper.destroy(true, true);
                }
            }
        });
    }

    initSwipers();
    window.addEventListener('resize', initSwipers);
});
